import { useCallback, useRef, useState } from 'react';

import { Iconbutton, Tally } from '@stratumn/atomic';

import { Add, Minus } from '@stratumn/icons';

import InfoTooltip from '@/components/ui/utils/infoTooltip';

type Props = {
  collapsed?: boolean;
  rowCount?: number;
  onToggle: () => void;
};

export const GroupButton = ({
  collapsed = false,
  rowCount = 0,
  onToggle
}: Props) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const enableTooltip = useCallback(() => setShowTooltip(true), []);
  const disableTooltip = useCallback(() => setShowTooltip(false), []);
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="relative mr-[3px] w-[26px]" ref={containerRef}>
      <Iconbutton
        label={collapsed ? 'Uncollapse' : 'Collapse'}
        onBlur={disableTooltip}
        onClick={onToggle}
        onFocus={enableTooltip}
        onMouseLeave={disableTooltip}
        onMouseOver={enableTooltip}
        variant={collapsed ? 'float' : 'outline'}
      >
        {collapsed ? <Add /> : <Minus />}
      </Iconbutton>
      {collapsed && (
        <div className="-translate-y-1/2 absolute top-0 right-0 translate-x-1/3 scale-75 transform">
          <Tally backgroundColor="indigo1" color="white1" value={rowCount} />
        </div>
      )}
      {showTooltip && collapsed && (
        <InfoTooltip
          backgroundColor="indigo2"
          clientRef={containerRef}
          delay={100}
          position={{
            place: 'right',
            placeShift: 3,
            adjustPlace: true,
            anchor: 'left'
          }}
          text={`${rowCount} row${rowCount > 1 ? 's' : ''} grouped`}
          textColor="white"
        />
      )}
    </div>
  );
};
